const getForSignatureField = ({ field, errors }) => {
    const mhData = [];

    if (field.isRequired && !field.value) {
        errors.push({ id: field.id, errorType: `field ${field.title} needs to be signed` });
    }
    const result = {
        id: field.id,
        value: field.value,
        isVisible: field.isVisible,
        mhData
    };
    if (field.signedDate) result.signedDate = field.signedDate;
    return result;
};

module.exports = getForSignatureField;
